import {GAME_TYPES} from "../../constants/game";
import {selectCurrentPlayer, selectGameType, selectPlayers} from "../../redux/reducers/sharedStateReducer/selectors";
import {selectUserId} from "../../redux/reducers/privateStateReducer/selectors";
import {getSpectatorMock} from "./getSpectatorMock";

// Маска бота под ручным управлением — один объект на объект игрока из
// состояния. Иначе каждый вызов давал бы новый объект, и эффекты с
// actingPlayer в зависимостях (таймер хода в CompletePhaseButton)
// перезапускались бы на каждом рендере. Бот в состоянии поменялся — это уже
// другой объект, и маска для него строится заново
const controlledBotMasks = new WeakMap();

const getControlledBotMask = (controlledBot) => {
  let mask = controlledBotMasks.get(controlledBot);
  if (!mask) {
    mask = {...controlledBot, isBot: false};
    controlledBotMasks.set(controlledBot, mask);
  }
  return mask;
};

export const getActingPlayer = (gameType, userId, players, currentPlayer) => {
  if (gameType === GAME_TYPES.LOCAL) {
    return currentPlayer;
  }

  // Просмотр записи матча: даже если зритель — участник исходного матча,
  // во время воспроизведения он всегда зритель, а не действующий игрок
  // (иначе CompletePhaseButton мог бы диспатчить реальные действия поверх
  // сценария ReplayRunner в параллельных этапах SETUP/COMBAT)
  if (gameType === GAME_TYPES.REPLAY) {
    return getSpectatorMock();
  }

  const player = players.find((player) => player.id === userId);
  if (player) {
    return player;
  }

  // Админ, перехвативший управление ботом (зритель чужого матча, см.
  // controlledBots): действует за этого игрока со всем интерфейсом игрока.
  // Для интерфейса такой бот — живой игрок (isBot: false): иначе проверки вида
  // «!actingPlayer.isBot» (перехват инициативы, маркеры расстановки) прятали бы
  // от него возможности игрока. Состояние партии при этом не меняется
  const controlledBot = userId
    ? players.find((candidate) => candidate.isBot && candidate.botControlledByUserId === userId)
    : null;
  if (controlledBot) {
    return getControlledBotMask(controlledBot);
  }

  return getSpectatorMock();
}

export const getActingPlayerFromState = (state) => {
  const gameType = selectGameType(state);
  const userId = selectUserId(state);
  const players = selectPlayers(state);
  const currentPlayer = selectCurrentPlayer(state);

  return getActingPlayer(gameType, userId, players, currentPlayer);
}
